var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { class: { noHeader: _vm.showOverlay } }, [
      _c("div", { staticClass: "headerMobile" }, [
        _c(
          "div",
          {
            staticClass: "menuBtn",
            class: { menuBtnOpen: _vm.showMobileMenu },
            on: { click: _vm.openMenu }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "36px",
                  height: "36px",
                  viewBox: "0 0 36 36",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                }
              },
              [
                _c("defs", [
                  _c("polygon", {
                    attrs: { id: "path-1", points: "0 0 36 0 36 36 0 36" }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d:
                        "M14.667,13 L25.5,13 L25.5,14.667 L14.667,14.667 L14.667,17.167 L10.5,13.833 L14.667,10.5 L14.667,13 Z M18,21.333 L25.5,21.333 L25.5,23 L18,23 L18,21.333 Z M18,17.167 L25.5,17.167 L25.5,18.833 L18,18.833 L18,17.167 Z",
                      id: "path-3"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  {
                    attrs: {
                      id: "Page-1",
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("g", { attrs: { id: "menuClose" } }, [
                      _c("use", {
                        attrs: {
                          id: "arrow-left",
                          fill: "#FFFFFF",
                          "xlink:href": "#path-3"
                        }
                      })
                    ])
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "logo" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "72",
                height: "32",
                viewBox: "0 0 72 32"
              }
            },
            [
              _c("g", { attrs: { fill: "#FFF", "fill-rule": "evenodd" } }, [
                _c("path", {
                  attrs: {
                    d:
                      "M69.429 21.076l-.145.287c-.331.606-.476.85-.953 1.497-.617.085-.874.114-1.36.114-1.54 0-4.08-.562-6.101-1.343l-3.486-1.337c-2.355-.889-4.508-1.402-6.074-1.402-1.315 0-3.611.49-5.215 1.095l-4.34 1.644c-2.044.806-4.56 1.343-6.074 1.343-1.527 0-4.03-.537-6.082-1.343l-4.346-1.644c-1.59-.606-3.896-1.095-5.214-1.095-1.555 0-3.72.513-6.084 1.402l-3.477 1.337c-2.017.781-4.556 1.343-6.11 1.343-.492 0-.733-.029-1.336-.114-.452-.582-.622-.869-.964-1.497l-.14-.287c1.171.222 1.833.315 2.481.315 1.54 0 3.755-.516 6.07-1.43l3.476-1.337c1.845-.714 4.593-1.29 6.084-1.29 1.494 0 4.236.576 6.073 1.29L29.6 19.96c2.313.915 4.528 1.43 6.068 1.43 1.558 0 3.773-.515 6.088-1.43l3.485-1.336c1.825-.714 4.574-1.29 6.061-1.29 1.504 0 4.25.576 6.083 1.29l3.486 1.336c2.313.915 4.529 1.43 6.074 1.43.652 0 1.304-.092 2.485-.314zm-5.533 4.438c-.528.555-.67.688-1.27 1.154l-2.779-.98-3.218-1.087c-2.437-.844-4.086-1.196-5.495-1.196-1.272 0-3.6.486-5.149 1.085l-4.284 1.665c-2 .779-4.503 1.312-6.02 1.332-1.52 0-4.019-.553-6.02-1.332l-4.293-1.665c-1.538-.599-3.864-1.085-5.148-1.085-1.404 0-3.053.352-5.502 1.196l-3.21 1.087-2.774.98c-.597-.466-.735-.599-1.273-1.154l4.994-1.777c2.2-.779 3.134-1.071 4.317-1.38 1.252-.311 2.533-.51 3.448-.51 1.459 0 4.223.597 6.01 1.29l3.431 1.353c2.33.912 4.451 1.399 6.02 1.399 1.555 0 3.696-.509 6.02-1.4l3.44-1.353c1.77-.692 4.539-1.29 5.993-1.29.916 0 2.187.2 3.45.512 1.21.308 2.072.58 4.32 1.379l4.992 1.777zm-5.533 2.602l-1.731 1.043-.393-.132c-2.007-.713-3.746-1.09-5.075-1.09-1.356 0-2.972.333-5.166 1.09l-.847.312-.874.332-.856.332-.866.332-.855.333-.866.287C39.02 31.6 36.998 32 35.684 32c-1.54 0-3.445-.421-6.026-1.332l-.861-.333-.862-.332-.86-.332-.87-.332-.851-.312-.862-.287c-1.431-.491-3.184-.803-4.29-.803-1.337 0-3.068.377-5.09 1.09l-.387.132-1.73-1.043c.436-.179.57-.222 1.168-.447l.865-.286c1.721-.598 3.875-1.024 5.16-1.024 1.522 0 3.518.446 6.016 1.31l.87.333.86.333.863.337.86.335.86.305c1.847.667 3.832 1.09 5.152 1.09 1.551 0 3.417-.423 6.03-1.395l.856-.335.866-.337.856-.333c.149-.065.429-.174.874-.333l.847-.286c1.723-.598 3.88-1.024 5.157-1.024 1.525 0 3.532.446 6.025 1.31l.87.333.313.114zM10.074 6.979v3.97c-.89.365-1.77.569-2.644.569-2.277 0-3.862-1.813-3.862-4.357 0-2.745 1.906-4.679 4.635-4.679 1.53 0 3.043.447 4.874 1.423V1.262C10.738.286 9.588 0 7.847 0 3.06 0 0 2.769 0 7.124 0 11.254 2.973 14 7.43 14c1.985 0 4.347-.648 6.07-1.685V6.98h-3.426M15.429 0v14h3.543V2.652h1.53c2.006 0 2.904.646 2.904 2.112 0 1.504-1.003 2.368-2.77 2.368l-.77-.025h-.401L24.39 14h4.539l-4.53-5.622c1.69-.793 2.576-2.174 2.576-3.983 0-2.974-1.86-4.395-5.753-4.395h-5.793M46.286 0v14h3.245V8.01h5.731V14H58.5V0h-3.238v5.17h-5.73V0zM61.714 0v14H72v-2.737h-6.717V7.928h4.95V5.3h-4.95V2.737h5.936V0zM32.38 7.002c0-2.68 1.745-4.56 4.263-4.56 2.509 0 4.261 1.88 4.261 4.56 0 2.678-1.752 4.557-4.26 4.557-2.51 0-4.264-1.879-4.264-4.557m-3.451 0c0 4.04 3.255 6.998 7.714 6.998 4.448 0 7.714-2.958 7.714-6.998C44.348 2.962 41.1 0 36.643 0c-4.459 0-7.714 2.962-7.714 7.002"
                  }
                })
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "profileMobile" },
          [
            _c("router-link", { attrs: { to: "/profile" } }, [
              _c("div", { staticClass: "icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "16px",
                      height: "16px",
                      viewBox: "0 0 16 16",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Page-1",
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M8,8 C5.795,8 4,6.205 4,4 C4,1.795 5.794,0 8,0 C10.206,0 12,1.795 12,4 C12,6.205 10.206,8 8,8 Z M8,9 C12.711,9 16,11.467 16,15 L16,16 L0,16 L0,15 C0,11.467 3.29,9 8,9 Z",
                            id: "profile",
                            fill: "#526173",
                            "fill-rule": "nonzero"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "menuMobile", class: { menuOpen: _vm.showMobileMenu } },
        [
          _c(
            "div",
            { staticClass: "navigationMobile" },
            [
              _c("h1", [_vm._v("Menu")]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/home" } }, [
                _c("div", [
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.showMobileMenu = false
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "linkIcon",
                          class: { active: this.$route.name === "home" },
                          attrs: {
                            width: "18px",
                            height: "18px",
                            viewBox: "0 0 18 18",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink"
                          }
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Page-1",
                                stroke: "none",
                                "stroke-width": "1",
                                fill: "none",
                                "fill-rule": "evenodd"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M6.3,14.087 C6.4268461,13.21773 6.9642498,12.4626108 7.744,12.058 L4.737,6.045 C4.6403502,5.8517003 4.7187003,5.6166498 4.912,5.52 C5.1052997,5.4233502 5.3403502,5.5017003 5.437,5.695 L8.485,11.791 C8.653,11.759 8.824,11.739 9,11.739 C10.35815,11.7427159 11.5078274,12.7425094 11.7,14.087 L16.417,14.087 C17.4488761,12.5913671 18.0010164,10.8170539 18,9 C18,4.037 13.963,0 9,0 C4.037,0 0,4.037 0,9 C0,10.887 0.586,12.638 1.583,14.087 L6.301,14.087 L6.3,14.087 Z M16.684,9.794 L15.604,10.154 C15.3991795,10.2214036 15.1782997,10.1111868 15.109,9.907 C15.0410074,9.7021371 15.1514252,9.4808545 15.356,9.412 L16.436,9.052 C16.5685455,9.0076991 16.7146569,9.0374755 16.8192954,9.1301128 C16.9239339,9.2227502 16.9712025,9.3641746 16.9432954,9.5011128 C16.9153884,9.6380511 16.8165455,9.7496991 16.684,9.794 Z M16.886,7.045 C17.006,7.225 16.956,7.468 16.776,7.587 L15.696,8.307 C15.6099487,8.3650302 15.5042754,8.3862659 15.4024867,8.3659833 C15.300698,8.3457006 15.2112356,8.2855818 15.154,8.199 C15.0963783,8.1124669 15.0755909,8.0065486 15.0962322,7.9046557 C15.1168735,7.8027627 15.1772438,7.7132853 15.264,7.656 L16.344,6.936 C16.5238917,6.8170578 16.7660744,6.8657624 16.886,7.045 Z M15.564,4.466 C15.7191858,4.3275637 15.955469,4.3344044 16.1023859,4.4815869 C16.2493027,4.6287693 16.2557164,4.8650646 16.117,5.02 L15.037,6.1 C14.8837305,6.2522892 14.6362695,6.2522892 14.483,6.1 C14.3301621,5.9469571 14.3301621,5.6990429 14.483,5.546 L15.563,4.466 L15.564,4.466 Z M12.969,4.207 L13.69,2.767 C13.793615,2.5872468 14.0193507,2.5193627 14.2049251,2.6121499 C14.3904994,2.7049371 14.4716336,2.926256 14.39,3.117 L13.67,4.557 C13.6074785,4.682043 13.4829967,4.7642326 13.3434456,4.7726089 C13.2038944,4.7809852 13.0704752,4.7142756 12.9934455,4.5976089 C12.9164159,4.4809422 12.9074785,4.332043 12.97,4.207 L12.969,4.207 Z M10.797,3.157 L11.517,1.357 C11.5645742,1.2212375 11.6828555,1.122564 11.8249478,1.1001017 C11.9670401,1.0776394 12.1099903,1.1350167 12.1971217,1.2494846 C12.284253,1.3639525 12.3014905,1.5170204 12.242,1.648 L11.522,3.448 C11.4841771,3.5447809 11.4091153,3.6223467 11.3136272,3.6633239 C11.2181391,3.7043011 11.1102048,3.7052651 11.014,3.666 C10.9177524,3.6275432 10.8407716,3.5523561 10.8000566,3.4570418 C10.7593417,3.3617275 10.7582418,3.2541266 10.797,3.158 L10.797,3.157 Z M8.609,0.783 C8.609,0.5670567 8.7840567,0.392 9,0.392 C9.2159433,0.392 9.391,0.5670567 9.391,0.783 L9.391,2.943 C9.391,3.1589433 9.2159433,3.334 9,3.334 C8.7840567,3.334 8.609,3.1589433 8.609,2.943 L8.609,0.783 Z M5.975,1.139 C6.0713796,1.1003516 6.1791926,1.1017348 6.2745489,1.1428432 C6.3699052,1.1839515 6.4449305,1.2613903 6.483,1.358 L7.203,3.158 C7.2548035,3.2876874 7.2334845,3.4351604 7.1470737,3.5448672 C7.0606628,3.6545741 6.922288,3.7098478 6.7840737,3.6898672 C6.6458593,3.6698867 6.5288035,3.5776874 6.477,3.448 L5.757,1.648 C5.7182618,1.5516063 5.7194768,1.4437591 5.7603771,1.3482627 C5.8012773,1.2527663 5.8784999,1.1774723 5.975,1.139 Z M3.785,2.593 C3.9780626,2.496615 4.2127196,2.574387 4.31,2.767 L5.03,4.207 C5.1116336,4.397744 5.0304994,4.6190629 4.8449251,4.7118501 C4.6593507,4.8046373 4.433615,4.7367532 4.33,4.557 L3.61,3.117 C3.5144316,2.9239204 3.5925865,2.6899024 3.785,2.593 Z M1.883,4.466 C2.0359273,4.3138267 2.2830727,4.3138267 2.436,4.466 L3.516,5.546 C3.6509324,5.7013941 3.642722,5.9346753 3.4971987,6.0801987 C3.3516753,6.225722 3.1183941,6.2339325 2.963,6.099 L1.883,5.019 C1.8094142,4.9458024 1.7680414,4.8462919 1.7680414,4.7425 C1.7680414,4.6387081 1.8094142,4.5391976 1.883,4.466 Z M1.114,7.045 C1.2339726,6.8651443 1.4769112,6.8163776 1.657,6.936 L2.737,7.656 C2.9063252,7.7798261 2.9481598,8.0150075 2.8319234,8.18963 C2.7156869,8.3642524 2.4825798,8.4164205 2.303,8.308 L1.223,7.588 C1.0431443,7.4680274 0.9943776,7.2250888 1.114,7.045 Z M1.068,9.299 C1.1372943,9.0942923 1.3588759,8.9839482 1.564,9.052 L2.644,9.412 C2.7765455,9.4563009 2.8753884,9.5679489 2.9032954,9.7048871 C2.9312025,9.8418254 2.8839339,9.9832498 2.7792954,10.0758872 C2.6746569,10.1685245 2.5285455,10.1983009 2.396,10.154 L1.316,9.794 C1.2173931,9.7613568 1.1358272,9.6908199 1.0893003,9.5979536 C1.0427733,9.5050874 1.0351096,9.3975247 1.068,9.299 Z M2.192,14.869 L15.808,14.869 C14.1035118,16.8550948 11.6172219,17.9985398 9,18 C6.3828799,17.999058 3.8965102,16.8559415 2.192,14.87 L2.192,14.869 Z",
                                  id: "dash-path",
                                  fill: "#FFFFFF",
                                  "fill-rule": "nonzero"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.linkMenuText.link1) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/swagger" } }, [
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.showMobileMenu = false
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "linkIcon",
                        class: { active: this.$route.name === "swagger" },
                        attrs: {
                          width: "18px",
                          height: "18px",
                          viewBox: "0 0 18 18",
                          version: "1.1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink"
                        }
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "Page-1",
                              stroke: "none",
                              "stroke-width": "1",
                              fill: "none",
                              "fill-rule": "evenodd"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M17.973,2.49 C17.967,2.476 17.959,2.464 17.951,2.45 C17.9374127,2.42393174 17.9209791,2.39944906 17.902,2.377 C17.8590396,2.33155325 17.8064074,2.29635118 17.748,2.274 C17.738,2.271 17.73,2.264 17.719,2.262 L9.094,0.012 C9.03230135,-0.0035772411 8.96769865,-0.0035772411 8.906,0.012 L0.28,2.262 C0.27,2.265 0.263,2.271 0.252,2.274 C0.209021339,2.28900003 0.169307984,2.3120813 0.135,2.342 C0.0991666796,2.37165904 0.0698819322,2.40843523 0.049,2.45 C0.041,2.463 0.032,2.475 0.027,2.49 C0.00956453461,2.53289388 0.000403372274,2.5786997 0,2.625 L0,17.625 C0,17.832 0.168,18 0.375,18 L17.625,18 C17.8321068,18 18,17.8321068 18,17.625 L18,2.625 C17.9994546,2.57871449 17.9902987,2.53293485 17.973,2.49 Z M9,0.763 L14.702,2.25 L3.298,2.25 L9,0.763 Z M17.25,17.25 L16.5,17.25 L16.5,13.125 C16.5,12.9178932 16.3321068,12.75 16.125,12.75 L15.75,12.75 L15.75,10.875 C15.75,10.6678932 15.5821068,10.5 15.375,10.5 L13.125,10.5 C12.9178932,10.5 12.75,10.6678932 12.75,10.875 L12.75,12.75 L11.625,12.75 C11.4178932,12.75 11.25,12.9178932 11.25,13.125 L11.25,17.25 L10.5,17.25 L10.5,14.625 C10.5,14.4178932 10.3321068,14.25 10.125,14.25 L7.125,14.25 C6.91789322,14.25 6.75,14.4178932 6.75,14.625 L6.75,17.25 L6,17.25 L6,14.625 C6,14.4178932 5.83210678,14.25 5.625,14.25 L5.25,14.25 L5.25,11.625 C5.25,11.4178932 5.08210678,11.25 4.875,11.25 L1.875,11.25 C1.66789322,11.25 1.5,11.4178932 1.5,11.625 L1.5,17.25 L0.75,17.25 L0.75,9 L17.25,9 L17.25,17.25 Z M17.25,6 L0.75,6 L0.75,5.25 L17.25,5.25 L17.25,6 Z",
                                id: "stock",
                                fill: "#FFFFFF",
                                "fill-rule": "nonzero"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.linkMenuText.link2) +
                        "\n          "
                    )
                  ]
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "header",
        { class: { open: _vm.sidebarOpen, closed: !_vm.sidebarOpen } },
        [
          _c(
            "div",
            { staticClass: "sizeToggle", on: { click: _vm.sizeToggle } },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "36px",
                    height: "36px",
                    viewBox: "0 0 36 36",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink"
                  }
                },
                [
                  _c("defs", [
                    _c("polygon", {
                      attrs: { id: "path-1", points: "0 0 36 0 36 36 0 36" }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M14.667,13 L25.5,13 L25.5,14.667 L14.667,14.667 L14.667,17.167 L10.5,13.833 L14.667,10.5 L14.667,13 Z M18,21.333 L25.5,21.333 L25.5,23 L18,23 L18,21.333 Z M18,17.167 L25.5,17.167 L25.5,18.833 L18,18.833 L18,17.167 Z",
                        id: "path-3"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Page-1",
                        stroke: "none",
                        "stroke-width": "1",
                        fill: "none",
                        "fill-rule": "evenodd"
                      }
                    },
                    [
                      _c("g", { attrs: { id: "menuClose" } }, [
                        _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                          _c("use", { attrs: { "xlink:href": "#path-1" } })
                        ]),
                        _vm._v(" "),
                        _c("use", {
                          attrs: {
                            id: "menuCloseBG",
                            fill: "#32A2F9",
                            "xlink:href": "#path-1"
                          }
                        }),
                        _vm._v(" "),
                        _c("mask", { attrs: { id: "mask-4", fill: "white" } }, [
                          _c("use", { attrs: { "xlink:href": "#path-3" } })
                        ]),
                        _vm._v(" "),
                        _c("use", {
                          attrs: {
                            id: "arrow-left",
                            fill: "#FFFFFF",
                            "xlink:href": "#path-3"
                          }
                        })
                      ])
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "logo" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "72",
                  height: "32",
                  viewBox: "0 0 72 32"
                }
              },
              [
                _c("g", { attrs: { fill: "#FFF", "fill-rule": "evenodd" } }, [
                  _c("path", {
                    attrs: {
                      d:
                        "M69.429 21.076l-.145.287c-.331.606-.476.85-.953 1.497-.617.085-.874.114-1.36.114-1.54 0-4.08-.562-6.101-1.343l-3.486-1.337c-2.355-.889-4.508-1.402-6.074-1.402-1.315 0-3.611.49-5.215 1.095l-4.34 1.644c-2.044.806-4.56 1.343-6.074 1.343-1.527 0-4.03-.537-6.082-1.343l-4.346-1.644c-1.59-.606-3.896-1.095-5.214-1.095-1.555 0-3.72.513-6.084 1.402l-3.477 1.337c-2.017.781-4.556 1.343-6.11 1.343-.492 0-.733-.029-1.336-.114-.452-.582-.622-.869-.964-1.497l-.14-.287c1.171.222 1.833.315 2.481.315 1.54 0 3.755-.516 6.07-1.43l3.476-1.337c1.845-.714 4.593-1.29 6.084-1.29 1.494 0 4.236.576 6.073 1.29L29.6 19.96c2.313.915 4.528 1.43 6.068 1.43 1.558 0 3.773-.515 6.088-1.43l3.485-1.336c1.825-.714 4.574-1.29 6.061-1.29 1.504 0 4.25.576 6.083 1.29l3.486 1.336c2.313.915 4.529 1.43 6.074 1.43.652 0 1.304-.092 2.485-.314zm-5.533 4.438c-.528.555-.67.688-1.27 1.154l-2.779-.98-3.218-1.087c-2.437-.844-4.086-1.196-5.495-1.196-1.272 0-3.6.486-5.149 1.085l-4.284 1.665c-2 .779-4.503 1.312-6.02 1.332-1.52 0-4.019-.553-6.02-1.332l-4.293-1.665c-1.538-.599-3.864-1.085-5.148-1.085-1.404 0-3.053.352-5.502 1.196l-3.21 1.087-2.774.98c-.597-.466-.735-.599-1.273-1.154l4.994-1.777c2.2-.779 3.134-1.071 4.317-1.38 1.252-.311 2.533-.51 3.448-.51 1.459 0 4.223.597 6.01 1.29l3.431 1.353c2.33.912 4.451 1.399 6.02 1.399 1.555 0 3.696-.509 6.02-1.4l3.44-1.353c1.77-.692 4.539-1.29 5.993-1.29.916 0 2.187.2 3.45.512 1.21.308 2.072.58 4.32 1.379l4.992 1.777zm-5.533 2.602l-1.731 1.043-.393-.132c-2.007-.713-3.746-1.09-5.075-1.09-1.356 0-2.972.333-5.166 1.09l-.847.312-.874.332-.856.332-.866.332-.855.333-.866.287C39.02 31.6 36.998 32 35.684 32c-1.54 0-3.445-.421-6.026-1.332l-.861-.333-.862-.332-.86-.332-.87-.332-.851-.312-.862-.287c-1.431-.491-3.184-.803-4.29-.803-1.337 0-3.068.377-5.09 1.09l-.387.132-1.73-1.043c.436-.179.57-.222 1.168-.447l.865-.286c1.721-.598 3.875-1.024 5.16-1.024 1.522 0 3.518.446 6.016 1.31l.87.333.86.333.863.337.86.335.86.305c1.847.667 3.832 1.09 5.152 1.09 1.551 0 3.417-.423 6.03-1.395l.856-.335.866-.337.856-.333c.149-.065.429-.174.874-.333l.847-.286c1.723-.598 3.88-1.024 5.157-1.024 1.525 0 3.532.446 6.025 1.31l.87.333.313.114zM10.074 6.979v3.97c-.89.365-1.77.569-2.644.569-2.277 0-3.862-1.813-3.862-4.357 0-2.745 1.906-4.679 4.635-4.679 1.53 0 3.043.447 4.874 1.423V1.262C10.738.286 9.588 0 7.847 0 3.06 0 0 2.769 0 7.124 0 11.254 2.973 14 7.43 14c1.985 0 4.347-.648 6.07-1.685V6.98h-3.426M15.429 0v14h3.543V2.652h1.53c2.006 0 2.904.646 2.904 2.112 0 1.504-1.003 2.368-2.77 2.368l-.77-.025h-.401L24.39 14h4.539l-4.53-5.622c1.69-.793 2.576-2.174 2.576-3.983 0-2.974-1.86-4.395-5.753-4.395h-5.793M46.286 0v14h3.245V8.01h5.731V14H58.5V0h-3.238v5.17h-5.73V0zM61.714 0v14H72v-2.737h-6.717V7.928h4.95V5.3h-4.95V2.737h5.936V0zM32.38 7.002c0-2.68 1.745-4.56 4.263-4.56 2.509 0 4.261 1.88 4.261 4.56 0 2.678-1.752 4.557-4.26 4.557-2.51 0-4.264-1.879-4.264-4.557m-3.451 0c0 4.04 3.255 6.998 7.714 6.998 4.448 0 7.714-2.958 7.714-6.998C44.348 2.962 41.1 0 36.643 0c-4.459 0-7.714 2.962-7.714 7.002"
                    }
                  })
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm.environment !== "production"
              ? _c("h5", { staticClass: "environment" }, [
                  _vm._v(_vm._s(_vm.environment))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "nav",
            [
              _c("h1", [_vm._v("Menu")]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/swagger" } }, [
                _c(
                  "svg",
                  {
                    staticClass: "linkIcon",
                    class: { active: this.$route.name === "swagger" },
                    attrs: {
                      width: "18px",
                      height: "18px",
                      viewBox: "0 0 18 18",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Page-1",
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M6.3,14.087 C6.4268461,13.21773 6.9642498,12.4626108 7.744,12.058 L4.737,6.045 C4.6403502,5.8517003 4.7187003,5.6166498 4.912,5.52 C5.1052997,5.4233502 5.3403502,5.5017003 5.437,5.695 L8.485,11.791 C8.653,11.759 8.824,11.739 9,11.739 C10.35815,11.7427159 11.5078274,12.7425094 11.7,14.087 L16.417,14.087 C17.4488761,12.5913671 18.0010164,10.8170539 18,9 C18,4.037 13.963,0 9,0 C4.037,0 0,4.037 0,9 C0,10.887 0.586,12.638 1.583,14.087 L6.301,14.087 L6.3,14.087 Z M16.684,9.794 L15.604,10.154 C15.3991795,10.2214036 15.1782997,10.1111868 15.109,9.907 C15.0410074,9.7021371 15.1514252,9.4808545 15.356,9.412 L16.436,9.052 C16.5685455,9.0076991 16.7146569,9.0374755 16.8192954,9.1301128 C16.9239339,9.2227502 16.9712025,9.3641746 16.9432954,9.5011128 C16.9153884,9.6380511 16.8165455,9.7496991 16.684,9.794 Z M16.886,7.045 C17.006,7.225 16.956,7.468 16.776,7.587 L15.696,8.307 C15.6099487,8.3650302 15.5042754,8.3862659 15.4024867,8.3659833 C15.300698,8.3457006 15.2112356,8.2855818 15.154,8.199 C15.0963783,8.1124669 15.0755909,8.0065486 15.0962322,7.9046557 C15.1168735,7.8027627 15.1772438,7.7132853 15.264,7.656 L16.344,6.936 C16.5238917,6.8170578 16.7660744,6.8657624 16.886,7.045 Z M15.564,4.466 C15.7191858,4.3275637 15.955469,4.3344044 16.1023859,4.4815869 C16.2493027,4.6287693 16.2557164,4.8650646 16.117,5.02 L15.037,6.1 C14.8837305,6.2522892 14.6362695,6.2522892 14.483,6.1 C14.3301621,5.9469571 14.3301621,5.6990429 14.483,5.546 L15.563,4.466 L15.564,4.466 Z M12.969,4.207 L13.69,2.767 C13.793615,2.5872468 14.0193507,2.5193627 14.2049251,2.6121499 C14.3904994,2.7049371 14.4716336,2.926256 14.39,3.117 L13.67,4.557 C13.6074785,4.682043 13.4829967,4.7642326 13.3434456,4.7726089 C13.2038944,4.7809852 13.0704752,4.7142756 12.9934455,4.5976089 C12.9164159,4.4809422 12.9074785,4.332043 12.97,4.207 L12.969,4.207 Z M10.797,3.157 L11.517,1.357 C11.5645742,1.2212375 11.6828555,1.122564 11.8249478,1.1001017 C11.9670401,1.0776394 12.1099903,1.1350167 12.1971217,1.2494846 C12.284253,1.3639525 12.3014905,1.5170204 12.242,1.648 L11.522,3.448 C11.4841771,3.5447809 11.4091153,3.6223467 11.3136272,3.6633239 C11.2181391,3.7043011 11.1102048,3.7052651 11.014,3.666 C10.9177524,3.6275432 10.8407716,3.5523561 10.8000566,3.4570418 C10.7593417,3.3617275 10.7582418,3.2541266 10.797,3.158 L10.797,3.157 Z M8.609,0.783 C8.609,0.5670567 8.7840567,0.392 9,0.392 C9.2159433,0.392 9.391,0.5670567 9.391,0.783 L9.391,2.943 C9.391,3.1589433 9.2159433,3.334 9,3.334 C8.7840567,3.334 8.609,3.1589433 8.609,2.943 L8.609,0.783 Z M5.975,1.139 C6.0713796,1.1003516 6.1791926,1.1017348 6.2745489,1.1428432 C6.3699052,1.1839515 6.4449305,1.2613903 6.483,1.358 L7.203,3.158 C7.2548035,3.2876874 7.2334845,3.4351604 7.1470737,3.5448672 C7.0606628,3.6545741 6.922288,3.7098478 6.7840737,3.6898672 C6.6458593,3.6698867 6.5288035,3.5776874 6.477,3.448 L5.757,1.648 C5.7182618,1.5516063 5.7194768,1.4437591 5.7603771,1.3482627 C5.8012773,1.2527663 5.8784999,1.1774723 5.975,1.139 Z M3.785,2.593 C3.9780626,2.496615 4.2127196,2.574387 4.31,2.767 L5.03,4.207 C5.1116336,4.397744 5.0304994,4.6190629 4.8449251,4.7118501 C4.6593507,4.8046373 4.433615,4.7367532 4.33,4.557 L3.61,3.117 C3.5144316,2.9239204 3.5925865,2.6899024 3.785,2.593 Z M1.883,4.466 C2.0359273,4.3138267 2.2830727,4.3138267 2.436,4.466 L3.516,5.546 C3.6509324,5.7013941 3.642722,5.9346753 3.4971987,6.0801987 C3.3516753,6.225722 3.1183941,6.2339325 2.963,6.099 L1.883,5.019 C1.8094142,4.9458024 1.7680414,4.8462919 1.7680414,4.7425 C1.7680414,4.6387081 1.8094142,4.5391976 1.883,4.466 Z M1.114,7.045 C1.2339726,6.8651443 1.4769112,6.8163776 1.657,6.936 L2.737,7.656 C2.9063252,7.7798261 2.9481598,8.0150075 2.8319234,8.18963 C2.7156869,8.3642524 2.4825798,8.4164205 2.303,8.308 L1.223,7.588 C1.0431443,7.4680274 0.9943776,7.2250888 1.114,7.045 Z M1.068,9.299 C1.1372943,9.0942923 1.3588759,8.9839482 1.564,9.052 L2.644,9.412 C2.7765455,9.4563009 2.8753884,9.5679489 2.9032954,9.7048871 C2.9312025,9.8418254 2.8839339,9.9832498 2.7792954,10.0758872 C2.6746569,10.1685245 2.5285455,10.1983009 2.396,10.154 L1.316,9.794 C1.2173931,9.7613568 1.1358272,9.6908199 1.0893003,9.5979536 C1.0427733,9.5050874 1.0351096,9.3975247 1.068,9.299 Z M2.192,14.869 L15.808,14.869 C14.1035118,16.8550948 11.6172219,17.9985398 9,18 C6.3828799,17.999058 3.8965102,16.8559415 2.192,14.87 L2.192,14.869 Z",
                            id: "dash-path",
                            fill: "#FFFFFF",
                            "fill-rule": "nonzero"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.showLinkText
                  ? _c("div", [
                      _vm._v("\n            Documentation\n          ")
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/home" } }, [
                _c(
                  "svg",
                  {
                    staticClass: "linkIcon",
                    class: { active: this.$route.name === "home" },
                    attrs: {
                      width: "18px",
                      height: "18px",
                      viewBox: "0 0 18 18",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Page-1",
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M17.973,2.49 C17.967,2.476 17.959,2.464 17.951,2.45 C17.9374127,2.42393174 17.9209791,2.39944906 17.902,2.377 C17.8590396,2.33155325 17.8064074,2.29635118 17.748,2.274 C17.738,2.271 17.73,2.264 17.719,2.262 L9.094,0.012 C9.03230135,-0.0035772411 8.96769865,-0.0035772411 8.906,0.012 L0.28,2.262 C0.27,2.265 0.263,2.271 0.252,2.274 C0.209021339,2.28900003 0.169307984,2.3120813 0.135,2.342 C0.0991666796,2.37165904 0.0698819322,2.40843523 0.049,2.45 C0.041,2.463 0.032,2.475 0.027,2.49 C0.00956453461,2.53289388 0.000403372274,2.5786997 0,2.625 L0,17.625 C0,17.832 0.168,18 0.375,18 L17.625,18 C17.8321068,18 18,17.8321068 18,17.625 L18,2.625 C17.9994546,2.57871449 17.9902987,2.53293485 17.973,2.49 Z M9,0.763 L14.702,2.25 L3.298,2.25 L9,0.763 Z M17.25,17.25 L16.5,17.25 L16.5,13.125 C16.5,12.9178932 16.3321068,12.75 16.125,12.75 L15.75,12.75 L15.75,10.875 C15.75,10.6678932 15.5821068,10.5 15.375,10.5 L13.125,10.5 C12.9178932,10.5 12.75,10.6678932 12.75,10.875 L12.75,12.75 L11.625,12.75 C11.4178932,12.75 11.25,12.9178932 11.25,13.125 L11.25,17.25 L10.5,17.25 L10.5,14.625 C10.5,14.4178932 10.3321068,14.25 10.125,14.25 L7.125,14.25 C6.91789322,14.25 6.75,14.4178932 6.75,14.625 L6.75,17.25 L6,17.25 L6,14.625 C6,14.4178932 5.83210678,14.25 5.625,14.25 L5.25,14.25 L5.25,11.625 C5.25,11.4178932 5.08210678,11.25 4.875,11.25 L1.875,11.25 C1.66789322,11.25 1.5,11.4178932 1.5,11.625 L1.5,17.25 L0.75,17.25 L0.75,9 L17.25,9 L17.25,17.25 Z M17.25,6 L0.75,6 L0.75,5.25 L17.25,5.25 L17.25,6 Z",
                            id: "stock",
                            fill: "#FFFFFF",
                            "fill-rule": "nonzero"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.showLinkText
                  ? _c("div", [_vm._v("\n            Healthcheck\n          ")])
                  : _vm._e()
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "profile",
          class: { shadow: _vm.showProfile },
          on: {
            mouseover: function($event) {
              _vm.showProfile = true
            },
            mouseleave: function($event) {
              _vm.showProfile = false
            }
          }
        },
        [
          _c("div", { staticClass: "arrowDown" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "11px",
                  height: "6px",
                  viewBox: "0 0 11 6",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "Page-1",
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c(
                      "g",
                      { attrs: { id: "icon-arrow-down", fill: "#526173" } },
                      [
                        _c("polygon", {
                          attrs: {
                            id: "arrow-down",
                            points: "5.5 5.5 0.5 0.5 10.5 0.5"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "16px",
                  height: "16px",
                  viewBox: "0 0 16 16",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "Page-1",
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M8,8 C5.795,8 4,6.205 4,4 C4,1.795 5.794,0 8,0 C10.206,0 12,1.795 12,4 C12,6.205 10.206,8 8,8 Z M8,9 C12.711,9 16,11.467 16,15 L16,16 L0,16 L0,15 C0,11.467 3.29,9 8,9 Z",
                        id: "profile",
                        fill: "#526173",
                        "fill-rule": "nonzero"
                      }
                    })
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm.showProfile
            ? _c(
                "div",
                { staticClass: "profileLink" },
                [
                  _c("router-link", { attrs: { to: "/profile" } }, [
                    _vm._v("My Profile")
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showProfile
            ? _c("div", { staticClass: "logout" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.logOut()
                      }
                    }
                  },
                  [_vm._v("Logout")]
                )
              ])
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "main",
      {
        class: {
          open: _vm.sidebarOpen,
          closed: !_vm.sidebarOpen,
          login: _vm.showOverlay
        }
      },
      [_c("router-view")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ae05fb3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae05fb3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-component/app-component.vue
// module id = null
// module chunks = 